import { Navigate } from 'react-router-dom';
import type { FC } from 'react';
import { useTypedSelector } from '../../api/store';
import { useCheckAuth } from '../../hooks/use-check-auth';
import { AppRoute } from '../../common/enums/app/app-route.enum';

interface PublickRouteProps {
  component: FC;
}

const PublickRoute = ({ component: Component, ...rest }: PublickRouteProps) => {
  const { isAuthorized } = useTypedSelector((state) => state.auth);
  useCheckAuth();

  if (isAuthorized === 'needToCheck') return null;

  return isAuthorized === 'yes' ? (
    <Navigate to={{ pathname: AppRoute.CONTACTS }} />
  ) : (
    <Component {...rest} />
  );
};

export { PublickRoute };
